
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import { getBackClassifyList, getUserInfo, getPermission, getOwnDecorationStyle } from '@/utils/api';
import { treeTraversal } from '@/utils'

// import { menus } from '@/menus';

export default new Vuex.Store({
  state: {
    userInfo: {},//登录用户信息
    permissionTreeList: [],//权限树treeList  前端当做菜单来用
    backClassifyList: [],//后台分类
    selectedItem: JSON.parse(sessionStorage.getItem('selectedItem') as any) || {}, //app-tabs 用到了
    info: '',
    decoration: {}, // 装修数据
    businessModel: ''
  },
  mutations: {
    'M_USER_INFO': (state, value) => {
      state.userInfo = value;
    },
    BUSINESS_MODEL: (state, value) => {
      state.businessModel = value;
    },
    'M_PERMISSION_TREE_LIST': (state, value) => {
      state.permissionTreeList = value
    },
    'DECORATION': (state, value) => {
      state.decoration = value
    },
    BACK_CLASSIFY_LIST: (state, value) => {
      state.backClassifyList = value;
    },
    SELECTED: (state, val) => {
      state.selectedItem = val;
      sessionStorage.setItem('selectedItem', JSON.stringify(state.selectedItem));
    },
    INFO: (state, val) => {
      state.info = val
    }
  },
  actions: {
    /*
     *@description:'异步获取登录用户信息'
    */
    'A_GET_USERINFO': ({ commit }) => {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          commit('M_USER_INFO', res)
          resolve(res)
        })
          .catch(err => {
            reject(err)
          })
      });
    },
    BUSINESS_MODEL: ({ commit }, value) => {
      commit('BUSINESS_MODEL', localStorage.getItem('business_model'));
  },
    GET_BACK_CLASSIFY_LIST: ({ commit }) => {
      return new Promise((resolve, reject) => {
        getBackClassifyList()
          .then(res => {
            commit('BACK_CLASSIFY_LIST', res);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    'A_GET_PERMISSION_TREE': ({ commit,state }) => {
      return new Promise((resolve, reject) => {
        let mode = state.businessModel == 'OPEN' ? 1 : 2;

        const params = { mode,stauts:1,terminalType:3 }
        getPermission(params)
          .then((res) => {
            //  存一个 拉平的 权限 list  只包含 permissionType = 'MENU'  方便做 路由前置守卫拦截
            localStorage.setItem('permissionFlattenList', JSON.stringify(treeTraversal(res)))
            commit('M_PERMISSION_TREE_LIST', res ?? [])
            resolve(res ?? [])
          }).catch((err) => {
            commit('M_PERMISSION_TREE_LIST', [])
            reject(err)
          });
      })
    },
    A_GET_DECORATION({commit}){
      return new Promise((resolve, reject) => {
        getOwnDecorationStyle({})
          .then((data) => {
            localStorage.setItem('decoration', JSON.stringify(data))
            console.log(data)
            commit('DECORATION', data ?? {})
            resolve(data ?? {})
          }).catch((err) => {
            commit('DECORATION', [])
            reject(err)
          });
      })
    }
  }
});